import { render, staticRenderFns } from "./VerifySocialServicesDialog.vue?vue&type=template&id=69903439&"
import script from "./VerifySocialServicesDialog.vue?vue&type=script&lang=js&"
export * from "./VerifySocialServicesDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerifySocialServicesDialog.vue?vue&type=style&index=0&id=69903439&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports